import Swal from "sweetalert2";

export const loading = () =>
  Swal.fire({
    text: "Lütfen Bekleyiniz.",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
  });

export const failed = (text) =>
  Swal.fire({
    icon: "error",
    text: text,
    confirmButtonText: "Kapat",
  });

export const success = (text) =>
  Swal.fire({
    position: "top-end",
    icon: "success",
    title: text,
    showConfirmButton: false,
    timer: 1500,
  });
